// extracted by mini-css-extract-plugin
module.exports = {"manaCurve":"ManaCurvePanel_manaCurve__mbzcE"};